import type { ReactNode } from 'react';
import styles from './Card.module.css';

export type CardProps = {
  children: ReactNode;
  className?: string;
  elevated?: boolean;
};

export function Card({ children, className, elevated = true }: CardProps) {
  return (
    <div className={`${styles.card} ${elevated ? styles.elevated : ''} ${className ?? ''}`}>
      {children}
    </div>
  );
}
